import { FilterType } from "./FiltersPanel";

export const STATUS_COLOR_MAP = new Map<string, string>([
  ["CUSTOMER - Closed Won",               "#D32F2F"], // Red
  ["CUSTOMER - No Response",              "#C2185B"], // Pink
  ["CUSTOMER - At Risk",                  "#512DA8"], // Deep Purple
  ["CUSTOMER - Lost (C)",                 "#00796B"], // Teal
  ["CUSTOMER - Lost",                     "#388E3C"], // Green
  ["CUSTOMER - Inactive",                 "#F57C00"], // Orange
  ["PROSPECT - Verified",                 "#4A148C"], // Darker Purple
  ["PROSPECT - Sales Ready",              "#004D40"], // Darker Teal
  ["PROSPECT - Lost",                     "#33691E"], // Darker Light‑Green
  ["PROSPECT - Sales Qualified",          "#E65100"], // Darker Orange
  ["PROSPECT - Present",                  "#FF8F00"], // Darker Amber
  ["LEAD - Unqualified",                  "#1565C0"], // Soft Blue
  ["LEAD - Sales Rep",                    "#0277BD"], // Soft Light‑Blue
  ["LEAD - New",                          "#00838F"], // Soft Cyan
  ["LEAD - Established",                  "#9E9D24"], // Soft Lime
  ["LEAD - Lost (L)",                     "#F9A825"], // Soft Yellow
  ["LEAD - LEAD-INCOMPLETE",              "#4E342E"], // Soft Brown
  ["LEAD - LEAD-READY2SUBMIT",            "#424242"], // Soft Grey
  ["LEAD - LEAD-AWAITING-NETSUITE",       "#37474F"], // Soft Blue‑Grey
  ["LEAD - No Response",                  "#17172F"], // Softer Blue‑Grey
  ["BLANK",                               "#7E7E7E"], //gray
]);

export const SPECIALTY_COLOR_MAP = new Map<string, string>([
  ["RWS",                     "#E53935"], // Red
  ["BCHN",                    "#D81B60"], // Pink
  ["BS in Exercise Kinesiology","#8E24AA"], // Purple
  ["BS Nutrition",            "#5E35B1"], // Deep Purple
  ["CCN",                     "#3949AB"], // Indigo
  ["CNC",                     "#1E88E5"], // Blue
  ["CNS",                     "#039BE5"], // Light Blue
  ["CTNC",                    "#00ACC1"], // Cyan
  ["DC",                      "#00897B"], // Teal
  ["Dentist",                 "#43A047"], // Green
  ["DO",                      "#7CB342"], // Light Green
  ["DOM",                     "#C0CA33"], // Lime
  ["DSS-Health Coach",        "#FDD835"], // Yellow
  ["DSS-RN",                  "#FFB300"], // Amber
  ["DVM",                     "#FB8C00"], // Orange
  ["International",           "#F4511E"], // Deep Orange
  ["LAc",                     "#6D4C41"], // Brown
  ["LPC/LCSW",                "#757575"], // Grey
  ["MD",                      "#546E7A"], // Blue‑Grey
  ["Midwife",                 "#EF5350"], // Soft Red
  ["MS Nutrition",            "#EC407A"], // Soft Pink
  ["NANP Professional",       "#AB47BC"], // Soft Purple
  ["ND",                      "#7E57C2"], // Soft Deep‑Purple
  ["NTP",                     "#5C6BC0"], // Soft Indigo
  ["Nurse Practitioner",     "#42A5F5"], // Soft Blue
  ["OD",                      "#29B6F6"], // Soft Light‑Blue
  ["Other",                   "#26C6DA"], // Soft Cyan
  ["PA",                      "#26A69A"], // Soft Teal
  ["Pharmacist",              "#66BB6A"], // Soft Green
  ["PhD/PsyD",                "#9CCC65"], // Soft Light‑Green
  ["PT/DPT",                  "#D4E157"], // Soft Lime
  ["RD",                      "#FFEE58"], // Soft Yellow
  ["RN",                      "#FFCA28"], // Soft Amber
  ["BLANK",                   "#7E7E7E"], //gray
]);

export const TYPE_TITLE_MAP = new Map<FilterType, string>([
  ["last-check-in", "Days Since Last Check-In"],
  ["status", "Status"],
  ["until-follow-up", "Days Untill Follow-Up"],
  ["specialty-type", "Specialty Type"]
]);